module.exports = __webpack_public_path__ + "static/media/checkbox_checked.d0930a26.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/checkbox_checked.svg
// module id = 606
// module chunks = 0